import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import ListItemButton from '@mui/material/ListItemButton';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from "./redux/actions"




import { APIvar } from '../services/variables';
import styles from './Sifrator.module.css'
import { componentStyles } from '../services/elementDesign'

const useColor = APIvar.colorUse;
const thirdColor = APIvar.colorTerciary;
const backColor = APIvar.colorBackground;
const cardBackColor = APIvar.cardBackgrounColor;

document.documentElement.style.setProperty('--backColor', backColor);
document.documentElement.style.setProperty('--cardBackColor', cardBackColor);


const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
});

const Sifrator = () => {

    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch()

    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)


    const [selectedRadioButtonOption1, setSelectedRadioButtonOption1] = useState('')
    const handleRadioButtonOption1Click = (e) => {
        const clickedOption = e.target.value;
        if (selectedRadioButtonOption1 === clickedOption) {
            // If the same radio button is clicked again, uncheck it
            setSelectedRadioButtonOption1("");
        } else {
            // Otherwise, update the selected option
            setSelectedRadioButtonOption1(clickedOption);
        }
    };

    const [selectedRadioButtonOption2, setSelectedRadioButtonOption2] = useState('')
    const handleRadioButtonOption2Click = (e) => {
        const clickedOption = e.target.value;
        if (selectedRadioButtonOption2 === clickedOption) {
            // If the same radio button is clicked again, uncheck it
            setSelectedRadioButtonOption2("");
        } else {
            // Otherwise, update the selected option
            setSelectedRadioButtonOption2(clickedOption);
        }
    };

    const [displayedComponent, setDisplayedComponent] = useState(null);

    const pretraziButtonFunction = () => {
         dispatch(actions.isLoading());
        console.log("Pretraži podatke")
        setDisplayedComponent('div2');
        dispatch(actions.isNotLoading());
    }

    const [selectedRowsDiv2, setSelectedRowsDiv2] = useState([]);

    const handleRowClickDiv2 = (index) => {
        const selectedIndex = selectedRowsDiv2.indexOf(index);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = [...selectedRowsDiv2, index];
        } else {
            newSelected = [...selectedRowsDiv2.slice(0, selectedIndex), ...selectedRowsDiv2.slice(selectedIndex + 1)];
        }

        setSelectedRowsDiv2(newSelected);
    };

    const promijeniStatusAktivnoDiv1ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("promjeni status aktivno za tekucu stavku")
        dispatch(actions.isNotLoading());
    }

    const raspariTekucuStavkuDiv1ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("raspari tekucu stavku")
        dispatch(actions.isNotLoading());
    }

    const uparenoPrimijeniNaBureDiv1ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Upareno primijeni na bure")
        dispatch(actions.isNotLoading());
    }

    const samoIzDnevnihPromjenaDiv1ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Samo iz dnevnih promjena")
        dispatch(actions.isNotLoading());
    }

    const krajDiv1ButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Kraj")
        dispatch(actions.isNotLoading());
    }

    const DivComponent1 = () => {

        return (

            <div style={{ width: '100%', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <p style={{ fontWeight: 'bold' }}> Trenutno nema dostupnih podataka za prikaz. Molimo pretražite za dohvat podataka.</p>
            </div>

        )
    }

    const mockData = [
        {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }
    ];

    const uzmiMemoButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Uzmi MEMO")
        dispatch(actions.isNotLoading());
    }

    const potvrdiMjButtonFunction = () => {
        dispatch(actions.isLoading());
        console.log("Potvrdi Mj.")
        dispatch(actions.isNotLoading());
    }



    const [mjestaPredlozenaProgramskiOption, setSelectedMjestaPredlozenaProgramskiOption] = useState('');
    //MOCK DATA
    const mjestaPredlozenaProgramskiOptions = ['Option 1', 'Option 2', 'Option 3'];
    const handleSelectmjestaPredlozenaProgramskiChange = (e) => {
        setSelectedMjestaPredlozenaProgramskiOption(e.target.value);
    }


    const [svaMjestaUzupanijiOption, SetSvaMjestaUzupanijiOption] = useState('');
    //MOCK DATA
    const svaMjestaUzupanijiSelectOptions = ['Option 1', 'Option 2', 'Option 3'];
    const handleSelectSvaMjestaUzupanijiSelectChange = (e) => {
        SetSvaMjestaUzupanijiOption(e.target.value);
    }


    const DodatnoPretrazivanjeComponent = () => {
        return (
            <div className={styles.dodatnoPretrazivanjeListe}>

                <div className={styles.dodatnoPretrazivanjeBotuniClass}>
                    <div className={styles.kontenjerZaDodatneBotuneClass}>
                        <div className={styles.buttonContainer}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    uzmiMemoButtonFunction()
                                }}
                            >
                                Uzmi MEMO
                            </Button>
                        </div>
                    </div>

                    <div className={styles.kontenjerZaDodatneBotuneClass}>
                        <div className={styles.buttonContainer}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    potvrdiMjButtonFunction()
                                }}
                            >
                                Potvrdi Mj.
                            </Button>
                        </div>
                    </div>
                </div>


                <div className={styles.rowContainer}>
                    <div className={styles.redContainerDiv}>

                        <div className={styles.classForSpecificRowPrvi}>
                            <FormControl fullWidth>
                                <InputLabel id="mjestaPredlozenaProgramski">Mjesta predložena programski</InputLabel>
                                <Select
                                    labelId="mjestaPredlozenaProgramskiSelect"
                                    id="mjestaPredlozenaProgramski-select"
                                    value={mjestaPredlozenaProgramskiOption}
                                    label="Mjesta predložena programski"
                                    onChange={handleSelectmjestaPredlozenaProgramskiChange}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {mjestaPredlozenaProgramskiOptions.map((option, index) => (
                                        <MenuItem key={index} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        <div className={styles.classForSpecificRowDrugi}>
                            <FormControl fullWidth>
                                <InputLabel id="svaMjestaUzupaniji">Sva mjesta u županiji, te ostala u Hrvatskoj</InputLabel>
                                <Select
                                    labelId="svaMjestaUzupanijiSelect"
                                    id="svaMjestaUzupaniji-select"
                                    value={svaMjestaUzupanijiOption}
                                    label="Sva mjesta u županiji, te ostala u Hrvatskoj"
                                    onChange={handleSelectSvaMjestaUzupanijiSelectChange}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {svaMjestaUzupanijiSelectOptions.map((option, index) => (
                                        <MenuItem key={index} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </div>



            </div>
        )
    }



    const DivComponent2 = () => {
        return (
            <div className={styles.tableAndButtonContainer}>
                {/*Prvi box*/}
                <div className={styles.tableContainer}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {/* Define your table headers here */}
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 1</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 2</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 3</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 4</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 5</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 6</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 7</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 8</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 9</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 10</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 11</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 12</TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 13</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {mockData.map((item, index) => (
                                    <TableRow key={index} onClick={() => handleRowClickDiv2(index)} selected={selectedRowsDiv2.includes(index)}>
                                        {/* Map your data to the table rows */}
                                        <TableCell style={{ textAlign: 'center' }}>{item.column1}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column2}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column3}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column4}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column5}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column6}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column7}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column8}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column9}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column10}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column11}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column12}</TableCell>
                                        <TableCell style={{ textAlign: 'center' }}>{item.column13}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

                {/*Dodatni uvjeti box*/}
                {selectedRowsDiv2.length !== 0 && <DodatnoPretrazivanjeComponent />}

                {/*Botuni box*/}
                <div className={styles.buttonCard}>
                    <div className={styles.mainButtonContainer}>
                        <div className={styles.buttonContainer}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    promijeniStatusAktivnoDiv1ButtonFunction()
                                }}
                            >
                                Promjeni status AKTIVNO za tekuću stavku
                            </Button>
                        </div>
                        <div className={styles.buttonContainer}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    raspariTekucuStavkuDiv1ButtonFunction()
                                }}
                            >
                                RASPARI tekuću stavku
                            </Button>
                        </div>
                        <div className={styles.buttonContainer}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    uparenoPrimijeniNaBureDiv1ButtonFunction()
                                }}
                            >
                                Upareno primijeni na "bure" (radi sporo)
                            </Button>
                        </div>
                        <div className={styles.buttonContainer}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    samoIzDnevnihPromjenaDiv1ButtonFunction()
                                }}
                            >
                                Samo iz dnevnih promjena
                            </Button>
                        </div>
                        <div className={styles.buttonContainer}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    krajDiv1ButtonFunction()
                                }}
                            >
                                Kraj
                            </Button>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    return (
        <ThemeProvider theme={theme}>
            <div className={styles.mainContainer}>

                {/*container1*/}
                <div className={styles.container}>

                    {/*Prvi box*/}
                    <div className={styles.cardContainer}>
                        {/*Prvi red*/}
                        <div className={styles.redContainerDiv}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <FormControl fullWidth>
                                    <RadioGroup
                                        aria-labelledby="group"
                                        row
                                        name="radio-buttons-group"
                                        onClick={handleRadioButtonOption1Click}
                                        value={selectedRadioButtonOption1}
                                    >
                                        <FormControlLabel value="Option 1" control={<Radio />} label="Mjesta neuparena" />
                                        <FormControlLabel value="Option 2" control={<Radio />} label="Mjesta uparena nedavno" />
                                        <FormControlLabel value="Option 3" control={<Radio />} label="Ulice neuparene" />
                                        <FormControlLabel value="Option 4" control={<Radio />} label="Ulice neuparene nedavno" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <FormControl fullWidth>
                                    <RadioGroup
                                        aria-labelledby="group"
                                        row
                                        name="radio-buttons-group"
                                        onClick={handleRadioButtonOption2Click}
                                        value={selectedRadioButtonOption2}
                                    >
                                        <FormControlLabel value="Option 1" control={<Radio />} label="svi slogovi" />
                                        <FormControlLabel value="Option 2" control={<Radio />} label="aktivni" />
                                        <FormControlLabel value="Option 3" control={<Radio />} label="neaktivni" />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            <div>
                                <div className={styles.buttonContainer}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={() => {
                                            pretraziButtonFunction()
                                        }}
                                    >
                                        Pretraži
                                    </Button>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/*Tablica i ili botuni*/}
                    <div className={styles.tableAndButtonContainer}>
                        {/*Drugi box*/}
                        {displayedComponent === null && <DivComponent1 />}

                        {displayedComponent === 'div2' && <DivComponent2 />}

                    </div>



                </div>

            </div>
        </ThemeProvider>
    )

}

export default Sifrator;